import { render, staticRenderFns } from "./OrdreProfessionnel.vue?vue&type=template&id=a814b678"
import script from "./OrdreProfessionnel.vue?vue&type=script&lang=js"
export * from "./OrdreProfessionnel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports